module.exports = __webpack_public_path__ + "img/recognition.f17a5ce2.png";